import anonymous from './anonymous.json'
import header from './header.json'
import sidenav from './sidenav.json'
import user from './user.json'

export default {
  anonymous,
  header,
  sidenav,
  user
}
